import { CarouselProps } from '@widget/airdrop/components/Carousel';
import { boxCover, boxNames } from '@widget/airdrop/constants';

export const items: CarouselProps['items'] = [
  {
    animationInfo: { name: boxNames.rocket },
    imgInfo: { width: 44, height: 65, src: boxCover[boxNames.rocket] }
  },
  {
    animationInfo: { name: boxNames.toilet },
    imgInfo: { width: 53, height: 70, src: boxCover[boxNames.toilet] }
  },
  {
    animationInfo: { name: boxNames.car },
    imgInfo: { width: 87, height: 43, src: boxCover[boxNames.car] }
  },
  {
    animationInfo: { name: boxNames.flower },
    imgInfo: { width: 34, height: 76, src: boxCover[boxNames.flower] }
  }
];
